import { render } from "./Main.vue?vue&type=template&id=5418920e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=5418920e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1917936756/src/quotation-sales/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5418920e"]])

export default __exports__